module.exports = __webpack_public_path__ + "img/login-fail.0726b488.gif";